/* eslint-disable react-hooks/exhaustive-deps */
import { NavBar } from "../../../common/NavBar";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import { SiteCamerasTableAutoPatrol } from "./SiteCamerasTableAutoPatrol";
import { TabsComponet } from "./TabsComponet";
import { CancelButton } from "./CancelButton";
import { SaveChangesButton } from "./SaveChangesButton";
import { BreadCrumbsComponet } from "../../../common/BreadCrumbsComponent";
import BackdropLoadingScreen from "../../../common/BackdropLoadingScreen";
import { OrangeTextButton } from "../../../common/OrangeTextButton";
import CancelIcon from "@mui/icons-material/Cancel";
import { createLinksArray } from "./SiteAboutPageUtils/createLinksArray";
import FormGroup from "@mui/material/FormGroup";
import { SiteAboutDialogs } from "./SiteAboutDialogs";
import { SiteAboutAlerts } from "./SiteAboutAlerts";
import useWindowDimensions from "../../../common/useWindowDimensions";
import {
  AlertState,
  SiteCameras,
  SiteSchedule,
  PatchObject,
  Dispatcher,
} from "./SiteAboutPageUtils/siteAboutInterfaces";
import { IDLE_CONFIGURE_MOTION } from "./SiteAboutPageUtils/configureMotionStatus";
import { WireGuardEditSession } from "./WireGuardTabEditMode";
import { handleGetAllData } from "./SiteAboutPageUtils/handleGetAllData";
import { Alert } from "@mui/material";
import ErrorBoundary from "../../../../ErrorBoundary";
import { useSiteAboutStore } from "./siteAboutStore/siteAboutStore";
import { checkedCircleIcon } from "../../../common/checkedCircleIcon";
import { cancelIconRed } from "../../../common/cancelIconRed";
import { SchedulesTab } from "./SchedulesTab";
import { GeneralInfoTabAutoPatrol } from "./GeneralInfoTabAutoPatrol";
import { SchedulesTabAutopatrol } from "./SchedulesTabAutopatrol";
import {
  handleEditSchedulesClick,
  handleCancelSchedulesClick,
} from "./SiteAboutPageUtils/handleSchedulesEditMode";
import { saveAutoPatrolSchedulesOnly } from "./SiteAboutPageUtils/handleSaveChangesButtonClick";
import { useFeatureFlag } from "../../../../hooks/useFeatureFlag";
import { syncAutoPatrolFlexIgnoreZonesFromApi } from "./AutoPatrolFlexIgnoreZones";
import { createApi } from "../../../utils/createApi";

export const getNumbersAfterAboutSite = (url: string) => {
  if (window.location.href.includes("aboutsitesecret")) {
    const match = url.match(/\/aboutsitesecret\/(\d+)/);
    if (match) {
      return match[1];
    } else {
      return "";
    }
  } else {
    const match = url.match(/\/aboutsite\/(\d+)/);
    if (match) {
      return match[1];
    } else {
      return "";
    }
  }
};

export const SiteAboutAutoPatrol = ({
  permissions,
  navBarCollapsed,
  setNavBarCollapsed,
}: {
  permissions: any;
  navBarCollapsed: boolean;
  setNavBarCollapsed: Dispatcher<boolean>;
}) => {
  const [dataLoaded, setDataLoaded] = React.useState(false);
  const [loadProgressPercent, setLoadProgressPercent] = React.useState(5);
  const [loadProgressMessage, setLoadProgressMessage] = React.useState(
    "Loading site data..."
  );
  const [clickedTab, setClickedTab] = React.useState("three"); // Default to Schedules tab for AutoPatrol
  const [editMode, setEditMode] = React.useState(false);
  const [schedulesEditMode, setSchedulesEditMode] = React.useState(false);
  const [siteInfo, setSiteInfo] = React.useState<any>({});
  const [siteInfoBackup, setSiteInfoBackup] = React.useState<any>({});
  const [webhooksInfo, setWebhooksInfo] = React.useState<any>([]);
  const [activeTab, setActiveTab] = React.useState(<></>);
  const [vmsVariables, setVmsVariables] = React.useState<
    (string | string[] | undefined)[][]
  >([]);
  const [vmsVariablesBackup, setVmsVariablesBackup] = React.useState<
    (string | string[] | undefined)[][]
  >([]);
  const [patchObject, setPatchObject] = React.useState<PatchObject>({
    name: "",
  });
  const [siteSchedules, setSiteSchedules] = React.useState<SiteSchedule[]>([]);
  const [allSiteSchedules, setAllSiteSchedules] = React.useState<
    SiteSchedule[]
  >([]);
  const [webhooksPatchObject, setWebhooksPatchObject] = React.useState<any>({
    customer: getNumbersAfterAboutSite(location.href),
  });
  const [webhooksChangesMade, setWebhooksChangesMade] = React.useState(false);
  const [wireguardTunnels, setWireguardTunnels] = React.useState<any[]>([]);
  const wireguardTunnelsLoading = false;
  const [selectedWireguardTunnelId, setSelectedWireguardTunnelId] =
    React.useState<number | null>(null);
  const [wireguardChangesMade, setWireguardChangesMade] =
    React.useState(false);
  const wireGuardEditSessionRef = React.useRef<WireGuardEditSession | null>(
    null
  );

  const { width } = useWindowDimensions();

  const [alertState, setAlertState] = React.useState<AlertState>({
    changeSuccess: false,
    noCameraOrSchedule: false,
    noSchedule: false,
    activateSuccess: false,
    deactivateSuccess: false,
    disarmSuccess: false,
    armSuccess: false,
    armFail: false,
    syncSuccess: false,
    cameraDeleteSuccess: false,
    configureMotion: IDLE_CONFIGURE_MOTION,
    refreshCameraSuccess: false,
    refreshCameraFail: false,
    webhookChangesFail: false,
  });
  const [camerasNotDeployed, setCamerasNotDeployed] = React.useState(false);
  const [backdropLoadingScreenOn, setBackdropLoadingScreenOn] =
    React.useState(true);
  const [deleteSiteDialogOpen, setDeleteSiteDialogOpen] = React.useState(false);
  const [siteInfoChangesMade, setSiteInfoChangesMade] = React.useState(false);
  const [scheduleChangesMade, setScheduleChangesMade] = React.useState(false);
  const [siteCameras, setSiteCameras] = React.useState<SiteCameras>(
    localStorage.siteCameras ? JSON.parse(localStorage.siteCameras) : []
  );
  const [disarmDialogOpen, setDisarmDialogOpen] = React.useState(false);
  const [armDialogOpen, setArmDialogOpen] = React.useState(false);
  const [rebootDialogOpen, setRebootDialogOpen] = React.useState(false);
  const [activateSiteDialogOpen, setActivateSiteDialogOpen] =
    React.useState(false);
  const [deactivateSiteDialogOpen, setDeactivateSiteDialogOpen] =
    React.useState(false);
  const [deativateInquiryDialogOpen, setDeativateInquiryDialogOpen] =
    React.useState(false);
  const [noAutoAddCamerasDialogOpen, setNoAutoAddCamerasDialogOpen] =
    React.useState(false);

  const [siteDeployed, setSiteDeployed] = React.useState(true);

  const [aiLinkSite, setAiLinkSite] = React.useState(false);

  const deleteSiteText = (
    <>
      <CancelIcon fontSize="small" />
      &nbsp;DELETE Site
    </>
  );

  const ref = React.useRef<HTMLDivElement>(null);
  const isMountedRef = React.useRef(true);

  const [armedStatus, setArmedStatus] = React.useState(false);

  const [recordingServerData, setRecordingServerData] = React.useState({});

  const [recordingServerPatchObject, setRecordingServerPatchObject] =
    React.useState({});

  const [recordingServerChangesMade, setRecordingServerChangesMade] =
    React.useState(false);

  const [recordingServerVisible, setRecordingServerVisible] =
    React.useState(false);

  const [healthCheckData, setHealthCheckData] = React.useState({});

  const [cameraHealthPatchObject, setCameraHealthPatchObject] = React.useState(
    {}
  );

  const [cameraHealthChangesMade, setCameraHealthChangesMade] =
    React.useState(false);

  const [camerasRefreshing, setCamerasRefreshing] = React.useState(false);

  const [addCameraHealthDialogOpen, setAddCameraHealthDialogOpen] =
    React.useState(false);

  const [turnOffHealthDialogOpen, setTurnOffHealthDialogOpen] =
    React.useState(false);

  const [cameraCheckAlertOpen, setCameraCheckAlertOpen] = React.useState(
    localStorage.cameraCheckAlertOpen === "true"
  );

  const [
    activateSiteWithScheduleDialogOpen,
    setActivateSiteWithScheduleDialogOpen,
  ] = React.useState(false);

  const [armSiteFlexScheduleDialogOpen, setArmSiteFlexScheduleDialogOpen] =
    React.useState(false);
  // Flex picker flavor (ENG-1404): AutoPatrol reboots also go through the
  // shared dialogs, so thread the same arm/reboot flavor state.
  const [armSiteFlexScheduleDialogAction, setArmSiteFlexScheduleDialogAction] =
    React.useState<"arm" | "reboot">("arm");
  const [
    disarmSiteFlexScheduleDialogOpen,
    setDisarmSiteFlexScheduleDialogOpen,
  ] = React.useState(false);
  const [initialApFlexPresetSyncComplete, setInitialApFlexPresetSyncComplete] =
    React.useState(false);
  const initialApFlexPresetSyncKeyRef = React.useRef("");

  const {
    resetSiteAboutState,
    getHealthCheckMetricsData,
    prefetchSiteMetricsSimplified,
    backdropLoadingScreenOnEditingSchedule,
    autoPatrolSchedules,
    setAutoPatrolFlexIgnoreZonesEnabledForSite,
    setAutoPatrolFlexIgnoreZonesPresetsForCamera,
    setAutoPatrolFlexIgnoreZonesSelectedPresetForScheduleCamera,
  } = useSiteAboutStore();
  const { flags } = useFeatureFlag();
  const showAutoPatrolFlexIgnoreZones =
    flags.showAutoPatrolFlexIgnoreZones === true;
  const autoPatrolOnlySchedules = React.useMemo(
    () =>
      autoPatrolSchedules.filter(
        (schedule: any) => schedule?.patrolType === "AutoPatrol"
      ),
    [autoPatrolSchedules]
  );

  const handleSiteLoadPhase = React.useCallback(
    (
      phase:
        | "site-metadata"
        | "site-extra-fields"
        | "site-cameras"
        | "site-schedules-and-health"
        | "camera-row-prefetch-start"
        | "camera-row-prefetch-progress"
        | "camera-row-prefetch-complete",
      progress?: { completed: number; total: number }
    ) => {
      if (phase === "site-metadata") {
        setLoadProgressPercent(25);
        setLoadProgressMessage("Loading site fields...");
        return;
      }
      if (phase === "site-extra-fields") {
        setLoadProgressPercent(45);
        setLoadProgressMessage("Loading cameras...");
        return;
      }
      if (phase === "site-cameras") {
        setLoadProgressPercent(70);
        setLoadProgressMessage("Loading camera details...");
        return;
      }
      if (phase === "camera-row-prefetch-start") {
        const total = progress?.total ?? 0;
        setLoadProgressPercent(74);
        setLoadProgressMessage(
          total > 0
            ? `Loading camera details (0/${total})...`
            : "Loading camera details..."
        );
        return;
      }
      if (phase === "camera-row-prefetch-progress") {
        const completed = progress?.completed ?? 0;
        const total = progress?.total ?? 0;
        const ratio = total > 0 ? completed / total : 1;
        const clampedRatio = Math.max(0, Math.min(1, ratio));
        const percent = 74 + Math.round(clampedRatio * 8);
        setLoadProgressPercent(percent);
        setLoadProgressMessage(
          total > 0
            ? `Loading camera details (${completed}/${total})...`
            : "Saving camera details..."
        );
        return;
      }
      if (phase === "camera-row-prefetch-complete") {
        setLoadProgressPercent(82);
        setLoadProgressMessage("Loaded per-camera details...");
        return;
      }
      setLoadProgressPercent(85);
      setLoadProgressMessage("Loaded schedules and health data...");
    },
    []
  );

  React.useEffect(() => {
    isMountedRef.current = true;
    setInitialApFlexPresetSyncComplete(false);
    initialApFlexPresetSyncKeyRef.current = "";
    setLoadProgressPercent(5);
    setLoadProgressMessage("Loading site data...");
    resetSiteAboutState();
    handleGetAllData(
      getNumbersAfterAboutSite(location.href),
      navigate,
      setSiteInfo,
      setSiteSchedules,
      setSiteCameras,
      setActiveTab,
      setDataLoaded,
      setBackdropLoadingScreenOn,
      setAllSiteSchedules,
      setVmsVariables,
      setNoAutoAddCamerasDialogOpen,
      setArmedStatus,
      setAiLinkSite,
      setSiteDeployed,
      () => {}, // setSyncNeeded - not used in AutoPatrol
      setAlertState,
      setCamerasNotDeployed,
      () => {}, // setToolTipTitle - not used in AutoPatrol
      () => {}, // setConfigureMotion - not used in AutoPatrol
      setPatchObject,
      () => {}, // setArmButtonDisabled - not used in AutoPatrol
      setRecordingServerData,
      setRecordingServerPatchObject,
      setRecordingServerVisible,
      setHealthCheckData,
      setWebhooksInfo,
      setWebhooksPatchObject,
      () => isMountedRef.current,
      handleSiteLoadPhase
    );
    getHealthCheckMetricsData(
      navigate,
      getNumbersAfterAboutSite(location.href)
    );
    prefetchSiteMetricsSimplified?.(
      navigate,
      getNumbersAfterAboutSite(location.href)
    );
    localStorage.setItem("schedulesIndex", "0");
    localStorage.setItem("clickedSchedulesTab", "one");
    let cameraCheckTimerId: ReturnType<typeof setTimeout> | undefined;
    if (localStorage.cameraCheckAlertOpen === "true") {
      cameraCheckTimerId = setTimeout(() => {
        if (isMountedRef.current) {
          setCameraCheckAlertOpen(false);
          localStorage.setItem("cameraCheckAlertOpen", "false");
        }
      }, 10000);
    }
    return () => {
      isMountedRef.current = false;
      if (cameraCheckTimerId !== undefined) clearTimeout(cameraCheckTimerId);
    };
  }, []);

  React.useEffect(() => {
    const siteIdFromUrl = getNumbersAfterAboutSite(location.href);
    const handleRefreshSiteCamerasTable = () => {
      const AxiosUI = createApi("");
      AxiosUI.get(`camera/site/?customer__id=${siteIdFromUrl}`).then((response) => {
        localStorage.setItem("siteCameras", JSON.stringify(response.data));
        setSiteCameras(response.data);
      });
    };

    window.addEventListener(
      "refreshSiteCamerasTable",
      handleRefreshSiteCamerasTable
    );
    return () => {
      window.removeEventListener(
        "refreshSiteCamerasTable",
        handleRefreshSiteCamerasTable
      );
    };
  }, []);

  const setScrollTop = (event: any) => {
    localStorage.setItem("siteAboutScrollTop", event.target.scrollTop);
  };

  React.useEffect(() => {
    if (ref) {
      setTimeout(() => {
        if (ref.current !== null) {
          ref.current.scrollTop = localStorage.siteAboutScrollTop;
        }
      }, 500);
    }
  }, [backdropLoadingScreenOn]);

  React.useEffect(() => {
    localStorage.setItem("navigatedFromSitesAboutPage", "true");
    localStorage.setItem(
      "allSiteSchedulesBackup",
      JSON.stringify(siteSchedules)
    );
  }, []);

  React.useEffect(() => {
    if (!dataLoaded) {
      setInitialApFlexPresetSyncComplete(false);
      initialApFlexPresetSyncKeyRef.current = "";
      return;
    }
    if (!showAutoPatrolFlexIgnoreZones || !siteInfo?.id) {
      setInitialApFlexPresetSyncComplete(true);
      setLoadProgressPercent(100);
      setLoadProgressMessage("Finalizing...");
      return;
    }
    if (autoPatrolOnlySchedules.length === 0) {
      setInitialApFlexPresetSyncComplete(true);
      setLoadProgressPercent(100);
      setLoadProgressMessage("Finalizing...");
      return;
    }
    const siteId = Number(siteInfo.id);
    const syncKey = `${siteId}:${autoPatrolOnlySchedules
      .map((schedule: any) => Number(schedule.id))
      .join(",")}`;
    if (initialApFlexPresetSyncKeyRef.current === syncKey) {
      return;
    }
    initialApFlexPresetSyncKeyRef.current = syncKey;
    const shouldCompleteInitialLoad = !initialApFlexPresetSyncComplete;
    if (shouldCompleteInitialLoad) {
      setLoadProgressPercent(90);
      setLoadProgressMessage("Loading flex schedule presets...");
    }
    void (async () => {
      const {
        autoPatrolFlexIgnoreZonesPresetsByCamera: currentPresetsByCamera,
      } = useSiteAboutStore.getState();
      try {
        await syncAutoPatrolFlexIgnoreZonesFromApi({
          siteId,
          schedules: autoPatrolOnlySchedules as any,
          existingPresetsByCamera: currentPresetsByCamera,
          setEnabledForSite: setAutoPatrolFlexIgnoreZonesEnabledForSite,
          setPresetsForCamera: setAutoPatrolFlexIgnoreZonesPresetsForCamera,
          setSelectedPresetForScheduleCamera:
            setAutoPatrolFlexIgnoreZonesSelectedPresetForScheduleCamera,
        });
      } finally {
        if (isMountedRef.current) {
          if (shouldCompleteInitialLoad) {
            setLoadProgressPercent(100);
            setLoadProgressMessage("Finalizing...");
          }
          setInitialApFlexPresetSyncComplete(true);
        }
      }
    })();
  }, [
    dataLoaded,
    showAutoPatrolFlexIgnoreZones,
    siteInfo?.id,
    autoPatrolOnlySchedules,
    setAutoPatrolFlexIgnoreZonesEnabledForSite,
    setAutoPatrolFlexIgnoreZonesPresetsForCamera,
    setAutoPatrolFlexIgnoreZonesSelectedPresetForScheduleCamera,
    initialApFlexPresetSyncComplete,
  ]);

  const waitForInitialAutoPatrolFlexSync =
    dataLoaded &&
    showAutoPatrolFlexIgnoreZones &&
    autoPatrolOnlySchedules.length > 0 &&
    !initialApFlexPresetSyncComplete;

  // Set Schedules tab as default for autopatrol sites
  React.useEffect(() => {
    if (siteInfo?.integration_type_name === "autopatrol") {
      setClickedTab("three");
      setActiveTab(<SchedulesTab siteInfo={siteInfo} />);
    }
  }, [siteInfo?.integration_type_name]);

  const navigate = useNavigate();

  // AutoPatrol-specific breadcrumb navigation to /sites_patrol
  const handleSiteBreadcrumbClick = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    event.preventDefault();
    localStorage.setItem("siteAboutScrollTop", "0");
    localStorage.setItem("expandedObjectSaved", "false");
    localStorage.setItem("navigatedFromSitesAboutPage", "true");
    localStorage.setItem("level0Click", "true");
    localStorage.setItem("sitesTablePage", "0");

    localStorage.setItem(
      "storedSelectedIndex",
      JSON.stringify({
        level1: [],
        level2: [],
        level3: [],
        level4: [],
        level5: [],
        level6: [],
      })
    );
    // AutoPatrol sites navigate to /sites_patrol
    navigate("/sites_patrol");
  };

  return (
    <div>
      <div>
        {cameraCheckAlertOpen && (
          <Alert
            severity="info"
            onClose={() => {
              setCameraCheckAlertOpen(false);
              localStorage.setItem("cameraCheckAlertOpen", "false");
            }}
          >
            Camera check is running in the background. This may take a few
            minutes. You will be alerted when it is complete. Please do not
            close your window or refresh any page until the check has been
            completed.
          </Alert>
        )}
        <SiteAboutDialogs
          setDeleteScheduleDialogOpen={() => {}} // Managed by zustand store
          setBackdropLoadingScreenOn={setBackdropLoadingScreenOn}
          setAllSiteSchedules={setAllSiteSchedules}
          setSiteInfo={setSiteInfo}
          editMode={editMode}
          setActiveTab={setActiveTab}
          siteInfo={siteInfo}
          setScheduleChangesMade={setScheduleChangesMade}
          rebootDialogOpen={rebootDialogOpen}
          setRebootDialogOpen={setRebootDialogOpen}
          setAlertState={setAlertState}
          activateSiteDialogOpen={activateSiteDialogOpen}
          setActivateSiteDialogOpen={setActivateSiteDialogOpen}
          setPatchObject={setPatchObject}
          patchObject={patchObject}
          deactivateSiteDialogOpen={deactivateSiteDialogOpen}
          setDeactivateSiteDialogOpen={setDeactivateSiteDialogOpen}
          deativateInquiryDialogOpen={deativateInquiryDialogOpen}
          setDeativateInquiryDialogOpen={setDeativateInquiryDialogOpen}
          disarmDialogOpen={disarmDialogOpen}
          setDisarmDialogOpen={setDisarmDialogOpen}
          armDialogOpen={armDialogOpen}
          setArmDialogOpen={setArmDialogOpen}
          deleteSiteDialogOpen={deleteSiteDialogOpen}
          setDeleteSiteDialogOpen={setDeleteSiteDialogOpen}
          navigate={navigate}
          setSyncNeeded={() => {}} // Not used in AutoPatrol (no sync button)
          noAutoAddCamerasDialogOpen={noAutoAddCamerasDialogOpen}
          setNoAutoAddCamerasDialogOpen={setNoAutoAddCamerasDialogOpen}
          setArmedStatus={setArmedStatus}
          setArmButtonDisabled={() => {}} // Not used in AutoPatrol (no arm toggle)
          setEditMode={setEditMode}
          clickedTab={clickedTab}
          vmsVariables={vmsVariables}
          siteSchedules={siteSchedules}
          setSiteSchedules={setSiteSchedules}
          addCameraHealthDialogOpen={addCameraHealthDialogOpen}
          setAddCameraHealthDialogOpen={setAddCameraHealthDialogOpen}
          healthCheckData={healthCheckData}
          setCameraHealthPatchObject={setCameraHealthPatchObject}
          setCameraHealthChangesMade={setCameraHealthChangesMade}
          setHealthCheckData={setHealthCheckData}
          turnOffHealthDialogOpen={turnOffHealthDialogOpen}
          setTurnOffHealthDialogOpen={setTurnOffHealthDialogOpen}
          permissions={permissions}
          activateSiteWithScheduleDialogOpen={
            activateSiteWithScheduleDialogOpen
          }
          setActivateSiteWithScheduleDialogOpen={
            setActivateSiteWithScheduleDialogOpen
          }
          armSiteFlexScheduleDialogOpen={armSiteFlexScheduleDialogOpen}
          setArmSiteFlexScheduleDialogOpen={setArmSiteFlexScheduleDialogOpen}
          armSiteFlexScheduleDialogAction={armSiteFlexScheduleDialogAction}
          setArmSiteFlexScheduleDialogAction={
            setArmSiteFlexScheduleDialogAction
          }
          disarmSiteFlexScheduleDialogOpen={disarmSiteFlexScheduleDialogOpen}
          setDisarmSiteFlexScheduleDialogOpen={
            setDisarmSiteFlexScheduleDialogOpen
          }
          setToolTipTitle={() => {}} // Not used in AutoPatrol (no arm toggle tooltip)
        />
        <SiteAboutAlerts
          siteDeployed={siteDeployed}
          aiLinkSite={aiLinkSite}
          setBackdropLoadingScreenOn={setBackdropLoadingScreenOn}
          setSyncNeeded={() => {}} // Not used in AutoPatrol (no sync button)
          setAlertState={setAlertState}
          siteInfo={siteInfo}
          setSiteInfo={setSiteInfo}
          setAllSiteSchedules={setAllSiteSchedules}
          setActiveTab={setActiveTab}
          vmsVariables={vmsVariables}
          setSiteDeployed={setSiteDeployed}
          setDeativateInquiryDialogOpen={setDeativateInquiryDialogOpen}
          setSiteCameras={setSiteCameras}
          camerasNotDeployed={camerasNotDeployed}
          setCamerasNotDeployed={setCamerasNotDeployed}
          navigate={navigate}
          setVmsVariables={setVmsVariables}
          alertState={alertState}
          setEditMode={setEditMode}
          setClickedTab={setClickedTab}
          setArmButtonDisabled={() => {}} // Not used in AutoPatrol (no arm toggle)
          setArmedStatus={setArmedStatus}
          setRebootDialogOpen={setRebootDialogOpen}
        />
        <BackdropLoadingScreen
          openState={backdropLoadingScreenOn || waitForInitialAutoPatrolFlexSync}
          progressPercent={loadProgressPercent}
          message={loadProgressMessage}
        />
        <BackdropLoadingScreen
          openState={backdropLoadingScreenOnEditingSchedule}
        />
        {dataLoaded && (
          <div
            className={"bg-actuate-grey absolute w-full h-full overflow-scroll"}
            onScroll={setScrollTop}
            ref={ref}
          >
            <ErrorBoundary>
              <div
                className={
                  !navBarCollapsed
                    ? "absolute top-[15px] left-[150px] right-0 h-[59px] bg-white min-w-[1370px]"
                    : "absolute top-[15px] left-[75px] right-0 h-[59px] bg-white min-w-[1370px]"
                }
              >
                <div className="absolute top-[16px] left-[30px] right-[650px] overflow-x-auto">
                  <BreadCrumbsComponet
                    linksArray={createLinksArray(siteInfo.breadcrumb_info)}
                    handleClick={handleSiteBreadcrumbClick}
                    styling=""
                    breadcrumb_info={siteInfo.breadcrumb_info}
                    siteInfo={siteInfo}
                  />
                </div>

                <FormGroup>
                  {/* AutoPatrol Armed Status (Static Display) */}
                  <div className="absolute right-[390px] top-[15px] flex">
                    <div className="text-[16px] font-mulish">Armed</div>
                    <div className="ml-2">
                      {armedStatus ? checkedCircleIcon : cancelIconRed}
                    </div>
                  </div>

                  {/* AutoPatrol Active Status (Static Display) */}
                  <div className="absolute right-[535px] top-[15px] flex">
                    <div className="text-[16px] font-mulish">Active</div>
                    <div className="ml-2">
                      {siteInfo.active ? checkedCircleIcon : cancelIconRed}
                    </div>
                  </div>

                  {/* DELETE Site Button */}
                  <div className={"absolute top-[11px] right-52"}>
                    {permissions.delete_cameras && (
                      <OrangeTextButton
                        onClick={() => setDeleteSiteDialogOpen(true)}
                        text={deleteSiteText}
                        disabled={false}
                      />
                    )}
                  </div>
                </FormGroup>
              </div>
            </ErrorBoundary>
            <ErrorBoundary>
              <div
                className={
                  !navBarCollapsed
                    ? "absolute top-[93px] left-[150px] right-[1px] h-[60px] min-w-[1370px] bg-white"
                    : "absolute top-[93px] left-[75px] right-[1px] h-[60px] min-w-[1370px] bg-white"
                }
              >
                <p className="font-black font-mulish text-[20px] pt-3  indent-[15px]">
                  General Site Info
                </p>
                <div
                  className={
                    width > 1300
                      ? "absolute top-[12px] right-[20px]"
                      : "absolute top-[12px] left-[1008px]"
                  }
                >
                  {editMode && (
                    <SaveChangesButton
                      patchObject={patchObject}
                      setEditMode={setEditMode}
                      setSiteInfo={setSiteInfo}
                      setPatchObject={setPatchObject}
                      siteInfo={siteInfo}
                      clickedTab={clickedTab}
                      setActiveTab={setActiveTab}
                      vmsVariables={vmsVariables}
                      allSiteSchedules={allSiteSchedules}
                      siteSchedules={siteSchedules}
                      setAllSiteSchedules={setAllSiteSchedules}
                      setBackdropLoadingScreenOn={setBackdropLoadingScreenOn}
                      setAlertState={setAlertState}
                      setSyncNeeded={() => {}} // Not used in AutoPatrol
                      editMode={editMode}
                      setSchedulesTabActive={() => {}} // Not used in AutoPatrol
                      setClickedTab={setClickedTab}
                      siteInfoChangesMade={siteInfoChangesMade}
                      setSiteInfoChangesMade={setSiteInfoChangesMade}
                      scheduleChangesMade={scheduleChangesMade}
                      setScheduleChangesMade={setScheduleChangesMade}
                      setDeleteScheduleDialogOpen={() => {}} // Managed by zustand store
                      setSiteSchedules={setSiteSchedules}
                      setArmButtonDisabled={() => {}} // Not used in AutoPatrol
                      recordingServerChangesMade={recordingServerChangesMade}
                      recordingServerData={recordingServerData}
                      recordingServerPatchObject={recordingServerPatchObject}
                      setRecordingServerData={setRecordingServerData}
                      setRecordingServerPatchObject={
                        setRecordingServerPatchObject
                      }
                      setRecordingServerChangesMade={
                        setRecordingServerChangesMade
                      }
                      cameraHealthChangesMade={cameraHealthChangesMade}
                      healthCheckData={healthCheckData}
                      setHealthCheckData={setHealthCheckData}
                      cameraHealthPatchObject={cameraHealthPatchObject}
                      setCameraHealthPatchObject={setCameraHealthPatchObject}
                      setCameraHealthChangesMade={setCameraHealthChangesMade}
                      setArmedStatus={setArmedStatus}
                      webhooksChangesMade={webhooksChangesMade}
                      webhooksInfo={webhooksInfo}
                      setWebhooksInfo={setWebhooksInfo}
                      webhooksPatchObject={webhooksPatchObject}
                      setWebhooksPatchObject={setWebhooksPatchObject}
                      setWebhooksChangesMade={setWebhooksChangesMade}
                      setDeactivateSiteInsteadDialogOpen={() => {}} // Managed by zustand store
                      setActivateSiteWithScheduleDialogOpen={
                        setActivateSiteWithScheduleDialogOpen
                      }
                      wireguardChangesMade={wireguardChangesMade}
                      wireGuardEditSessionRef={wireGuardEditSessionRef}
                      setWireguardTunnels={setWireguardTunnels}
                      setWireguardChangesMade={setWireguardChangesMade}
                      wireguardTunnels={wireguardTunnels}
                      wireguardTunnelsLoading={wireguardTunnelsLoading}
                      selectedWireguardTunnelId={selectedWireguardTunnelId}
                      setSelectedWireguardTunnelId={
                        setSelectedWireguardTunnelId
                      }
                    />
                  )}
                </div>
                <div
                  className={
                    width > 1300
                      ? "absolute top-[12px] right-[200px]"
                      : "absolute top-[12px] left-[878px]"
                  }
                >
                  {editMode && (
                    <CancelButton
                      setEditMode={setEditMode}
                      clickedTab={clickedTab}
                      setActiveTab={setActiveTab}
                      siteInfo={siteInfo}
                      setRecordingServerPatchObject={
                        setRecordingServerPatchObject
                      }
                      healthCheckData={healthCheckData}
                      webhooksInfo={webhooksInfo}
                      siteInfoBackup={siteInfoBackup}
                      setSiteInfo={setSiteInfo}
                      vmsVariablesBackup={vmsVariablesBackup}
                      setVmsVariables={setVmsVariables}
                      wireguardTunnels={wireguardTunnels}
                      wireguardTunnelsLoading={wireguardTunnelsLoading}
                      selectedWireguardTunnelId={selectedWireguardTunnelId}
                      setSelectedWireguardTunnelId={
                        setSelectedWireguardTunnelId
                      }
                      clearWireGuardEditSession={() => {
                        wireGuardEditSessionRef.current = null;
                      }}
                      setWireguardChangesMade={setWireguardChangesMade}
                    />
                  )}
                </div>
              </div>
            </ErrorBoundary>
            <ErrorBoundary>
              <div
                className={
                  !navBarCollapsed
                    ? "absolute top-[148px] left-[150px] right-[1px] h-[17vh] min-w-[1370px]"
                    : "absolute top-[148px] left-[75px] right-[1px] h-[17vh] min-w-[1370px]"
                }
              >
                {/* {activeTab} */}
                <GeneralInfoTabAutoPatrol editMode={editMode} />

                <div className="flex w-full gap-4 overflow-hidden pt-[5px]">
                  <div className="min-w-0 flex-[2]">
                    {!camerasRefreshing && (
                      <SiteCamerasTableAutoPatrol
                        setAlertState={setAlertState}
                        siteCameras={siteCameras}
                        setSiteCameras={setSiteCameras}
                        setBackdropLoadingScreenOn={setBackdropLoadingScreenOn}
                        setNoAutoAddCamerasDialogOpen={
                          setNoAutoAddCamerasDialogOpen
                        }
                        siteInfo={siteInfo}
                        setSiteInfo={setSiteInfo}
                        setSiteSchedules={setSiteSchedules}
                        setActiveTab={setActiveTab}
                        setDataLoaded={setDataLoaded}
                        setAllSiteSchedules={setAllSiteSchedules}
                        setVmsVariables={setVmsVariables}
                        setArmedStatus={setArmedStatus}
                        setAiLinkSite={setAiLinkSite}
                        setSiteDeployed={setSiteDeployed}
                        setCamerasNotDeployed={setCamerasNotDeployed}
                        setToolTipTitle={() => {}}
                        setConfigureMotion={() => {}}
                        setPatchObject={setPatchObject}
                        setArmButtonDisabled={() => {}}
                        setRecordingServerData={setRecordingServerData}
                        setRecordingServerPatchObject={
                          setRecordingServerPatchObject
                        }
                        setRecordingServerVisible={setRecordingServerVisible}
                        setHealthCheckData={setHealthCheckData}
                        setCamerasRefreshing={setCamerasRefreshing}
                        permissions={permissions}
                        setWebhooksInfo={setWebhooksInfo}
                        setWebhooksPatchObject={setWebhooksPatchObject}
                        siteSchedules={siteSchedules}
                      />
                    )}
                  </div>
                  <div className="min-w-0 flex-[3]">
                    <SchedulesTabAutopatrol
                      editMode={schedulesEditMode}
                      permissions={permissions}
                      onEditSchedulesClick={() =>
                        handleEditSchedulesClick(setSchedulesEditMode)
                      }
                      onSaveSchedulesClick={() =>
                        saveAutoPatrolSchedulesOnly(navigate, () =>
                          setSchedulesEditMode(false)
                        )
                      }
                      onCancelSchedulesClick={() =>
                        handleCancelSchedulesClick(setSchedulesEditMode)
                      }
                    />
                  </div>
                </div>
              </div>
            </ErrorBoundary>
          </div>
        )}
      </div>
      <div className="justify-start">
        <NavBar
          navBarCollapsed={navBarCollapsed}
          setNavBarCollapsed={setNavBarCollapsed}
          props={{}}
        />
      </div>
    </div>
  );
};
